export default (): string => {
  if (process.browser) {
    return window.location.host;
  }

  return '';
};
